<template>
  <div class="vote-card--com" :class="'vote-card' + (index || cardData.ranking + 1)" @click="goDetail()">
    <div class="card-title">{{cardData.name}}</div>
    <div class="card-main">
      <img v-if="cardData.logo" :src="cardData.logo" alt="">
      <div class="number">
        编号：{{cardData.id}}
        <br>
        票数：{{mapNumb}}
      </div>
      <span class="action" @click.stop="doVote">支持</span>
    </div>
    <div class="card-rank">{{index || cardData.ranking + 1}}</div>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  props: ['index', 'cardData'],
  data () {
    return {
      loginFlag: Boolean(this.$route.query.token),
      mapNumb: this.cardData.votesNumbers
    }
  },
  methods: {
    downloadTip () {
      if (!this.loginFlag) {
        this.$emit('showDownload')
        return true
      }
      return false
    },
    goDetail () {
      if (this.downloadTip()) return false
      this.$router.push('/h5vote-detail?id=' + this.cardData.id + '&rank=' + (this.index || this.cardData.ranking + 1))
    },
    doVote () {
      if (this.downloadTip()) return false
      this.loading = this.$toast.loading()
      api.doVote({
        corporateId: this.cardData.id
      }).then(res => {
        this.loading && this.loading.hide()
        if (res.code === 200) {
          this.$toast.text('投票成功', {
            duration: 1200
          })
          this.mapNumb++
          this.$emit('voteNumberPlus')
        } else {
          this.$toast.text(res.message, {
            duration: 1800
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.vote-card--com {
  padding: 12px;
  border-radius: 4px;
  margin: 12px;
  position: relative;
  background: #DAE3F2 url('../../assets/rank.png') no-repeat;
  background-size: 40px;
  background-position: right top;
  &.vote-card1 {
    background: #EBDDC6 url('../../assets/rank1.png') no-repeat;
    background-size: 40px;
    background-position: right top;
    .card-rank {
      display: none;
    }
  }
  &.vote-card2 {
    background: #CBD1EB url('../../assets/rank2.png') no-repeat;
    background-size: 40px;
    background-position: right top;
    .card-rank {
      display: none;
    }
  }
  &.vote-card3 {
    background: #ECD1C5 url('../../assets/rank3.png') no-repeat;
    background-size: 40px;
    background-position: right top;
    .card-rank {
      display: none;
    }
  }
  .card-title {
    font-size: 18px;
    font-weight: bold;
    padding-right: 40px;
  }
  .card-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 24px;
    img {
      width: 100px;
      height: 100px;
      object-fit: contain;
    }
    .number {
      color: #83889a;
    }
    .action {
      width: 1rem;
      height: 34px;
      line-height: 34px;
      color: #fff;
      background: #ff9900;
      text-align: center;
      border-radius: 2px;
      cursor: pointer;
    }
  }
  .card-rank {
    position: absolute;
    right: 0;
    top: 7px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    background: linear-gradient(-30deg,#385171 24.68262%,#517199 50%,#39516f);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
